import { Component, ElementRef, HostListener, Input } from '@angular/core';

type DOMRectProps = 'bottom' | 'height' | 'left' | 'right' | 'top' | 'width' | 'x' | 'y';

@Component({
    selector: 'lib-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    standalone: false
})
export class TooltipComponent {
  @Input() customAnchor: boolean = false;
  @Input() placement: 'above' | 'below' | 'right' | 'above-carousel' = 'right';
  
  //The Swiper element uses some of its own styles that complicate displaying the tooltips correctly 
  //These inputs are only required when using the 'above-carousel' placement parameter.
  //The query selector for the carousel element, usually 'lib-carousel'
  @Input() carouselElement: string;

  //The slide index that the tooltip is on. Used to display correctly on mobile view.
  @Input() carouselSlideIndex: number;
  showTip: boolean = false;
  tapEvent: boolean = false;
  
  constructor(private elRef: ElementRef) {}

  ngOnInit() {
    document.addEventListener('touchstart', this.onDocumentTouchStart.bind(this));
  }

  ngOnDestroy() {
    document.removeEventListener('touchstart', this.onDocumentTouchStart.bind(this));
  }

  @HostListener('mouseenter', ['$event'])
  onHover(event: MouseEvent) {
    this.showTip = true;
  }

  @HostListener('mouseleave', ['$event'])
  onExit(event: MouseEvent) {
    this.tapEvent = false;
    this.showTip = false;
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    this.tapEvent = !this.tapEvent;
    this.showTip = this.tapEvent;
    event.stopPropagation(); // Prevent event propagation
  }

  onDocumentTouchStart(event: TouchEvent) {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.tapEvent = false;
      this.showTip = false;
    }
  }

  getTooltipStyles(tooltip: HTMLElement, anchor: HTMLElement): string {
    const height = this.#getRectProperty(tooltip, 'height');
    const left = this.#getRectProperty(anchor, 'left');
    const anchorWidth = this.#getRectProperty(anchor, 'width');

    let carouselLeft = 0;
    let carouselWidth = 0;
    if(this.carouselElement){
      carouselLeft = this.#getRectProperty(document.querySelector(this.carouselElement), 'left');
      carouselWidth = this.#getRectProperty(document.querySelector(this.carouselElement), 'width');
    }

    return `--tooltip-height: ${height}; --anchor-left: ${left}; --anchor-width: ${anchorWidth}; --carousel-left: ${carouselLeft}; --carousel-width: ${carouselWidth}; --carousel-slide-index: ${this.carouselSlideIndex}`;
  }

  #getRectProperty(element: HTMLElement, propName: DOMRectProps): number {
    const tooltipPositions = element?.getBoundingClientRect() ?? null;

    return tooltipPositions[propName] ?? 0;
  }
}